import { createActions, createReducer } from 'reduxsauce'

import DetalhesRecursoConcedidoService from '../../servicos/DetalhesRecursoConcedidoService'

/**
 * Action types & creators
 */
export const { Types, Creators } = createActions({
    buscaParecerComissaoRecursoConcedidoInicio: [],
    buscaParecerComissaoRecursoConcedidoSucesso: ['parecerComissaoRecursoConcedido'],
    buscaParecerComissaoRecursoConcedidoErro: ['erro'],
})

const INITIAL_STATE = {
    carregando: false,
    erro: null,
    lista: [],
}

// Ação para busca completa
Creators.buscaParecerComissaoRecursoConcedido = filtro => {
    return dispatch => {
        dispatch(Creators.buscaParecerComissaoRecursoConcedidoInicio())
        let serv = new DetalhesRecursoConcedidoService()
        return serv
            .consultarParecerComissao(filtro)
            .then(response => dispatch(Creators.buscaParecerComissaoRecursoConcedidoSucesso(response.data)))
            .catch(error => dispatch(Creators.buscaParecerComissaoRecursoConcedidoErro(error)))
    }
}

const buscaParecerComissaoRecursoConcedidoInicio = (state = INITIAL_STATE, action) => ({ ...state, carregando: true, erro: null })

const buscaParecerComissaoRecursoConcedidoErro = (state = INITIAL_STATE, action) => ({ ...state, erro: action.erro, carregando: false })

const buscaParecerComissaoRecursoConcedidoSucesso = (state = INITIAL_STATE, action) => {
    return { ...state, lista: action.parecerComissaoRecursoConcedido, carregando: false }
}

/**
 * Reducer
 */
export default createReducer(INITIAL_STATE, {
    [Types.BUSCA_PARECER_COMISSAO_RECURSO_CONCEDIDO_INICIO]: buscaParecerComissaoRecursoConcedidoInicio,
    [Types.BUSCA_PARECER_COMISSAO_RECURSO_CONCEDIDO_ERRO]: buscaParecerComissaoRecursoConcedidoErro,
    [Types.BUSCA_PARECER_COMISSAO_RECURSO_CONCEDIDO_SUCESSO]: buscaParecerComissaoRecursoConcedidoSucesso,
})
